import axios from 'axios';
import { API_URL } from '../config';
// import { getCookie } from '../function'

export default axios.create({
    baseURL : API_URL,
    headers : {
        "Content-Type":"application/json",
        // "Authorization": getCookie('token'),
        "x-api-key":'BiDY3T06Cq7EWRsdmGNoxaunSeYoH2eQ17cTDKek'
    },
})


// const result = await api.post(Apis.GetAllArticlePath, data, {
            // withCredentials: true,
        //     headers: { 'Content-Type': 'multipart/form-data' }
        // });